import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton,
  ModalBody, ModalFooter, Button, Box, Text, VStack, Divider
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

interface HistoricoDictamen {
  id: number;
  dictamenId: number;
  fechaCambio: string;
  tipo: string;
  operador: string;
  nombre: string;
  negocio: string | null;
  giro: string | null;
  direccion: string;
  colonia: string;
  estatusEntrega: string | null;
  estatusPago: string | null;
  montoPago: string | null;
  contenidoDictamen: string | null;
  folio: string | null;
  nomenclatura: string | null;
  latitud: string | null;
  longitud: string | null;
  observaciones: string | null;
  fechaEntrega: string | null;
  fechaSolicitud: string | null;
  tipoOperacion: string;
  camposModificados: string | null;
  motivoCambio: string;
  usuarioModificacion: string;
}

interface Props {
  isOpen: boolean;
  onClose: () => void;
  dictamenId: number;
}

export default function ModalHistorialDictamen({
  isOpen,
  onClose,
  dictamenId
}: Props) {
  const [historial, setHistorial] = useState<HistoricoDictamen[]>([]);

  useEffect(() => {
    if (isOpen && dictamenId) {
      fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/dictamenes/${dictamenId}/historico`)
        .then(res => res.json())
        .then(response => {
          if (response.success && Array.isArray(response.data)) {
            setHistorial(response.data);
          } else {
            setHistorial([]);
          }
        })
        .catch(err => {
          console.error('Error al obtener historial', err);
        });
    }
  }, [isOpen, dictamenId]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader
          bgImage="url('/img/bg.webp')"
          bgSize="cover"
          bgPosition="center"
          bgRepeat="no-repeat"
          color="white"
          textShadow="2px 2px 4px rgba(0,0,0,0.7)"
          fontWeight="bold"
          position="relative"
        >
          Historial de Cambios
        </ModalHeader>
        <ModalCloseButton color="white" _hover={{ bg: 'rgba(255,255,255,0.2)' }} />
        <ModalBody>
          {historial.length === 0 ? (
            <Text>No hay historial disponible.</Text>
          ) : (
            <VStack spacing={4} align="stretch">
              {historial.map((h, i) => (
                <Box key={i} p={4} borderWidth="1px" borderRadius="md" bg="gray.50">
                  <Text fontWeight="bold">Fecha de Cambio: {new Date(h.fechaCambio).toLocaleString()}</Text>
                  <Divider my={2} />
                  <Text><strong>Tipo:</strong> {h.tipo}</Text>
                  <Text><strong>Operador:</strong> {h.operador}</Text>
                  <Text><strong>Nombre:</strong> {h.nombre}</Text>
                  <Text><strong>Negocio:</strong> {h.negocio || 'N/A'}</Text>
                  <Text><strong>Giro:</strong> {h.giro || 'N/A'}</Text>
                  <Text><strong>Tipo de Operación:</strong> {h.tipoOperacion}</Text>
                  <Text><strong>Motivo:</strong> {h.motivoCambio}</Text>
                  <Text><strong>Usuario:</strong> {h.usuarioModificacion}</Text>
                  <Text><strong>Dirección:</strong> {h.direccion}</Text>
                  <Text><strong>Colonia:</strong> {h.colonia}</Text>
                  <Text><strong>Estatus Entrega:</strong> {h.estatusEntrega}</Text>
                  <Text><strong>Estatus Pago:</strong> {h.estatusPago}</Text>
                  <Text><strong>Monto Pago:</strong> ${h.montoPago ? parseFloat(h.montoPago.toString()).toFixed(2) : '0.00'}</Text>
                  <Divider my={2} />
                  {h.contenidoDictamen && (
                    <Box>
                      <Text fontWeight="semibold">Contenido del Dictamen:</Text>
                      <Box
                        borderWidth="1px"
                        borderRadius="md"
                        p={2}
                        mt={2}
                        bg="white"
                        dangerouslySetInnerHTML={{ __html: h.contenidoDictamen }}
                      />
                    </Box>
                  )}
                </Box>
              ))}
            </VStack>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
